import { render, staticRenderFns } from "./AssociatedDocuments.vue?vue&type=template&id=617972f5&scoped=true"
import script from "./AssociatedDocuments.vue?vue&type=script&lang=js"
export * from "./AssociatedDocuments.vue?vue&type=script&lang=js"
import style0 from "./AssociatedDocuments.vue?vue&type=style&index=0&id=617972f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617972f5",
  null
  
)

export default component.exports